export default __webpack_public_path__ + "static/media/reports-empty.ef944531.svg";